import { Component, Input } from '@angular/core';
import { WorkContact, WorkProject } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-intro',
  templateUrl: './ax-project-intro.component.html',
  styleUrls: ['./ax-project-intro.component.scss'],
})
export class AxProjectIntroComponent {
  @Input() project: WorkProject;
  @Input() contact: WorkContact;
  @Input() isInternalView = false;

  constructor() {
  }
}
